module.exports = __webpack_public_path__ + "img/title-bg1.8edc3531.png";